import { Navigate } from 'react-router-dom';

/**
 * Legacy LBS entry — questionnaire now starts at `/smokerprofile` for both brands.
 */
export default function LbsQ1() {
  return <Navigate to="/smokerprofile" replace />;
}
